import React from 'react';
import { makeStyles } from '../styles';
const useStyles = makeStyles(({ spacing, palette }) => ({
    root: {
        width: '100%',
        marginTop: spacing(2),
        marginBottom: spacing(2),
        border: `1px solid ${palette.grey.main}`,
    },
}));
export default ({ children }) => {
    const classes = useStyles();
    return React.createElement("table", { className: classes.root }, children);
};
//# sourceMappingURL=Table.js.map